module.exports = __webpack_public_path__ + "static/media/bg_price_plan_from_35_to_39.00791a73.webp";